import {createAction} from 'redux-actions';
import * as Constants from './constants';

export const postItemLog = createAction(Constants.POST_LOG_ITEM.REQUEST, (datas) => ({datas}));
export const getPusherComment = createAction(Constants.GET_PUSHER_COMMENT, (datas) => (datas));
export const getPusherCommentItem = createAction(Constants.GET_PUSHER_COMMENT_ITEM, (datas) => (datas));
export const changeOrderItemQuantity = createAction(Constants.CHANGE_ORDER_ITEM_QUANTITY, (datas) => (datas));
